import { useLayers } from './queries/layers/useLayers'
import { Layer } from '../types'
import { useQueryParams } from './useQueryParams'

interface Props {
  articleKey: string
}

export const useCurrentLayer = ({ articleKey }: Props) => {
  const { data } = useLayers({ articleKey })
  const { layer: layerId } = useQueryParams()
  const layerFinder = layerId ? (layer: Layer) => layer.id === layerId : (layer: Layer) => layer.is_main
  return (data?.layers || []).find(layerFinder)
}
